import { Interpolation, Theme } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { BannerNotification } from '@frontend/design-system';

type Props = {
  css?: Interpolation<Theme>;
};

export const AutoVerificationSuccessBanner = ({ ...rest }: Props) => {
  const { t } = useTranslation('insuranceDetails');

  return (
    <BannerNotification
      {...rest}
      status='success'
      message={t('EHR data was used to successfully verify the information')}
    />
  );
};
